import { Image, Page, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import variable from '../../shared/style/variable';
import LogoMaccaferri from '../image/LogoMaccaferri.png';
import styles from '../style';

interface IPageLayoutProps {
    children: React.ReactNode;
}

const Header = () => {
    const { t } = useTranslation();

    return (
        <View style={styles.header}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <View style={{ flexDirection: 'row' }}>
                    <Image src={LogoMaccaferri} style={{ height: 30, paddingRight: 20 }} />
                    <View style={{ flexDirection: 'column', justifyContent: 'space-between' }}>
                        <Text>{t('export_desc_one')}</Text>
                        <Text>{t('export_desc_two')}</Text>
                        <Text></Text>
                    </View>
                </View>
                <View style={{ flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Text>{t('export_header')}</Text>
                    <Text render={({ pageNumber, totalPages }) => t('pageOf', { pageNumber, totalPages })} fixed />
                </View>
            </View>
            <View style={{ marginTop: 15, border: `1px solid ${variable.turquoise_400}` }}></View>
        </View>
    );
};

const Footer = () => (
    <View style={styles.footer}>
        <View style={{ border: `1px solid ${variable.turquoise_400}` }} fixed></View>
    </View>
);

export default (props: IPageLayoutProps) => (
    <Page size='A4' style={styles.page}>
        <Header />
        <View style={{ height: '85%' }}>{props.children}</View>
        <Footer />
    </Page>
);
